import { render, staticRenderFns } from "./_FriendsModal.vue?vue&type=template&id=a8c16256&scoped=true&"
import script from "./_FriendsModal.vue?vue&type=script&lang=js&"
export * from "./_FriendsModal.vue?vue&type=script&lang=js&"
import style0 from "./_FriendsModal.vue?vue&type=style&index=0&id=a8c16256&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c16256",
  null
  
)

export default component.exports